// ----------------------------------------------------------------------

export default function IconButton() {
  return {
    MuiIconButton: {
      defaultProps: {
        size: 'medium',
      },
      styleOverrides: {
        root: {},
      },
    },
  };
}
